module.exports = "https://r.zoocdn.com/_next/static/images/hero-image-small-c26b867b6f20d47e860a02aef1606d78.jpg";